export default __webpack_public_path__ + "static/media/mamaearth-logo.11dbf6ef.svg";